import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "./ui/button";
import { AdminStatsAndSettings } from "./AdminStatsAndSettings";
import { useAuth } from "../context/AuthContext";

export const AdminPage = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/connexion?next=admin");
  }, [loading, user, navigate]);

  if (loading || !user) return null;

  if (user.role !== "admin") {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-4 text-center">
        <div className="w-14 h-14 rounded-2xl bg-red-500/15 border border-red-500/30 flex items-center justify-center">
          <ShieldAlert className="w-7 h-7 text-red-600" />
        </div>
        <div>
          <h2 className="font-heading text-xl font-bold mb-1">Accès réservé</h2>
          <p className="text-sm text-slate-500">
            Cet espace est réservé aux administrateurs.
          </p>
        </div>
        <Button
          onClick={() => navigate("/compte")}
          className="bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold"
        >
          Aller à mon espace
        </Button>
      </div>
    );
  }

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return <AdminStatsAndSettings onLogout={handleLogout} />;
};
